// extracted by mini-css-extract-plugin
export default {"title":"WaitingListDetails_title__wRK2u","total":"WaitingListDetails_total__ijpV0","pay":"WaitingListDetails_pay__CsjoC","edit":"WaitingListDetails_edit__Z3c+n"};